import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

export default withStyles({
  root: {
    whiteSpace: 'nowrap',
    width: 1,
  },
})(TableCell);
